module.exports = __webpack_public_path__ + "img/booking-active-icon.7e12704c.svg";